var _path, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 10C5 6.13401 8.13401 3 12 3C15.866 3 19 6.13401 19 10V18H5V10Z",
    stroke: "#111B48",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 17,
    width: 18,
    height: 2,
    rx: 1,
    fill: "#111B48"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 20,
    width: 6,
    height: 2,
    rx: 1,
    fill: "#111B48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellBlue);
export default __webpack_public_path__ + "static/media/bell-blue.882547095a6dd55a0d9758fa71a3a92b.svg";
export { ForwardRef as ReactComponent };